import { Component, ViewChild } from '@angular/core';
import { CheckPageAccess } from 'src/app/components/authorize/check-page-access';
import { NoResultsComponent } from 'src/app/components/no-results/no-results.component';
import { RoleOnboardingCourse } from 'src/app/components/role-onboarding/role-onboarding';
import { AuthService } from 'src/app/services/auth.service';
import { RoleOnboardingService } from 'src/app/services/role-onboarding.service';

@Component({
    selector: 'app-role-onboarding-list',
    templateUrl: './role-onboarding-list.component.html',
    styleUrls: ['./role-onboarding-list.component.scss'],
    standalone: false
})
export class RoleOnboardingListComponent {
  courses: RoleOnboardingCourse[] = [];
  roles: RoleRow[] = [];
  columnsToDisplay = ['Role', 'Title', 'Requirement', 'Status'];
  pageName = CheckPageAccess.ROLEONBOARDING;
  showAddButton = this.authService.getAccessControl().roleOnboardingManagement;
  information = '<h4>Status Definitions</h4><br/><span>Active:</span> Assigned users must complete this training before using the portal.<br/><br/><span>Inactive:</span> Users with this role are not blocked.';
  @ViewChild('noResults') noResults!: NoResultsComponent;

  constructor(
    private roleOnboardingService: RoleOnboardingService,
    private authService: AuthService) { }

  ngOnInit(): void {
    this.roleOnboardingService.getAll().subscribe({
      next: (data) => {
        this.courses = data ?? [];
        this.roles = this.groupByRole(this.courses);
        this.noResults?.setTotal(this.roles.length);
      }
    });
  }

  private groupByRole(courses: RoleOnboardingCourse[]): RoleRow[] {
    const map = new Map<number, RoleOnboardingCourse[]>();
    for (const course of courses) {
      map.set(course.role, [...(map.get(course.role) ?? []), course]);
    }

    return Array.from(map.values()).map(group => {
      const mandatory = group.filter(c => c.isMandatory).length;
      return {
        roleName: group[0].roleName,
        firstCourseId: group[0].id,
        courseCount: group.length,
        titles: group.map(c => c.title).join(', '),
        requirement: this.describeRequirement(mandatory, group.length - mandatory),
        status: group.some(c => c.isActive) ? 'Active' : 'Inactive'
      };
    });
  }

  private describeRequirement(mandatory: number, optional: number): string {
    const parts: string[] = [];
    if (mandatory > 0) {
      parts.push(`${mandatory} Mandatory`);
    }
    if (optional > 0) {
      parts.push(`${optional} Optional`);
    }
    return parts.join(', ');
  }
}

interface RoleRow {
  roleName: string;
  firstCourseId: number;
  courseCount: number;
  titles: string;
  requirement: string;
  status: string;
}
